export const TEAM = [
  {
    id: "reah",
    name: "Reah Menezes",
    position: "Founder & Director",
    experience: "QPFP®, MBA-Finance, M.Com.",
    specialization: "Goal-based solutions, portfolio strategy, client relationships",
    image: "/team/reah.png",
    description:
      "Leads strategy and client relationships with a relationship-first approach focused on clarity and long-term outcomes.",
  },
  {
    id: "anil",
    name: "Anil Kumar",
    position: "Head, Operations & Client Services",
    experience: "Extensive financial operations expertise",
    specialization: "Client servicing, process excellence, operations",
    image: "/team/anil.png",
    description:
      "Drives operational rigor and high-touch service so clients experience consistency across every interaction.",
  },
];
